import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: {
    messageKey: 'forms.asset-format.messages.name',
    validators: [
      validator('presence', true),
      validator('format', {
        regex: /^[a-zA-Z0-9]+(?:[-_][a-zA-Z0-9]+)*$/,
      }),
    ],
  },
});

export default class AssetFormatModel extends Model.extend(Validations) {
  @attr('string') commandTemplate;
  @attr('string') description;
  @attr('number') height;
  @attr('string') label;
  @attr('string') name;
  @attr('boolean') isCroppingFormat;
  @attr('boolean') isDownloadFormat;
  @attr('number') width;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsModified;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.label;
  }

  get croppingFormatLabel() {
    let label = this.label.replace('UMG Cropping Format', '');

    return `${this.id}: ${label}`;
  }

  get displayLabel() {
    return `${this.id}: ${this.label}`;
  }
}
